import ThemeConfig from "@mobiusjs/site-client/dist/ClientThemeConfig";

export default ThemeConfig.customize(ThemeConfig, {
    styles: ['fonts/fonts', 'theme'],
    scripts: ['runtime', 'mod', 'mod.react', 'theme'],
    themeColor: '#0a0a47',
    appleTouchIcon: '/images/logo-72.png'
});
